/**
 * @file Utilities to be used in meta-components that render documentation and information about commands. Should not
 * typically be used in most applications.
 */

export {getCommandMetadata, getServiceMetadata} from './commands'
export {
  getAllRegisteredCommands,
  type RegisteredUICommand,
  type RegisteredUICommandGroup,
  type RegisteredUIService,
} from './commands-registry'

export const UI_COMMANDS_SERVICE_ID = 'github'
export const GLOBAL_NAVIGATION_SERVICE_ID = 'global-navigation'
